//import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import StickyBox from "react-sticky-box"
import { Link } from "react-scroll"
//import { Container, Nav } from "react-bootstrap"

//import Logo from "../images/logo.svg"

const DocSidebar = ({ siteTitle }) => (
  <React.Fragment>
    <StickyBox offsetTop={160} offsetBottom={20}>
      <aside className="sidebar-container">
        <div className="sidebar">
          <div className="side-links">
            <span className="sub-heading">Api Docs</span>
            {/*<div className="side-menu">
              <Link to="intro" activeClass="active" spy={true} hashSpy={true} smooth={true} offset={-170} duration={500}>Introduction</Link>
                <Link to="getting-started" activeClass="active" spy={true} hashSpy={true} smooth={true} offset={-70} duration={500}>Getting Started</Link>
                <Link to="making-first-request" activeClass="active" spy={true} hashSpy={true} smooth={true} offset={-70} duration={500}>Making your first request</Link>
            </div> */}
            <ul>
              <li>
                <Link
                  to="intro"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-170}
                  duration={500}
                >
                  Introduction
                </Link>
              </li>
              <li>
                <Link
                  to="getting-started"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Getting Started
                </Link>
              </li>
              <li>
                <Link
                  to="making-first-request"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Making your first request
                </Link>
              </li>
              <li>
                <Link
                  to="parsing"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Parsing
                </Link>
              </li>
              <li>
                <Link
                  to="waiting-for-elements"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Waiting For Elements
                </Link>
              </li>
              <li>
                <Link
                  to="running-custom-javascript"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Running Custom JavaScript
                </Link>
              </li>
              <li>
                <Link
                  to="http-headers"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  HTTP Headers
                </Link>
              </li>
              <li>
                <Link
                  to="blocking-resources"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Blocking Resources
                </Link>
              </li>
              <li>
                <Link
                  to="sending-post-requests"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Sending Post Requests
                </Link>
              </li>
              <li>
                <Link
                  to="sessions"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Sessions <sup>Coming Soon</sup>
                </Link>
              </li>
              <li>
                <Link
                  to="proxies"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Proxies
                </Link>
              </li>
              <li>
                <Link
                  to="proxy-mode"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Proxy Mode <sup>Beta</sup>
                </Link>
              </li>
              <li>
                <Link
                  to="request-calculation"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Request Calculation
                </Link>
              </li>
              <li>
                <Link
                  to="response-codes"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Response Status Codes
                </Link>
              </li>
              <li>
                <Link
                  to="credits"
                  activeClass="active"
                  spy={true}
                  hashSpy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  Credits
                </Link>
              </li>
            </ul>
            {/*
            <span className="sub-heading">Api Endpoints</span>
            <ul>
              <li>
                <Link to="/docs/html" activeClass="active">Scraping Raw HTML</Link>
              </li>
              <li>
                <Link to="/docs/javascript" activeClass="active">JavaScript Rendering</Link>
              </li>
            </ul> */}
          </div>
        </div>
      </aside>
    </StickyBox>
  </React.Fragment>
)

DocSidebar.propTypes = {
  siteTitle: PropTypes.string,
}

DocSidebar.defaultProps = {
  siteTitle: ``,
}

export default DocSidebar
